import { LearningJourneyEntity, LearningJourneyEntryAttributes } from '../Journey'
import { LogoutAction } from '../User'
import { selectLibraryContent } from './Library.selectors'

export enum ShelfType {
  READING = 'reading',
  LISTENING = 'listening',
  FAVORITE = 'favorite',
  COMPLETED = 'completed',
  LEVELUP = 'level-up',
  LESSON = 'lesson'
}

export enum LevelUpType {
  SENTENCE_BUILDER = 'sentence_builder',
  WORD_CRAFT = 'word_craft',
  PRONUNCIATION = 'pronunciation'
}

export type ContentAccessInfo = {
  locked: boolean
}

export enum SpecialEntityTypes {
  Placeholder = 'placeholder'
}

export type PlaceholderEntry = { type: SpecialEntityTypes.Placeholder; attributes: LearningJourneyEntryAttributes }

export type ShelfEntry = LearningJourneyEntity | PlaceholderEntry

export interface PageResult {
  token: string
  hasBefore: boolean
  hasAfter: boolean
  total?: number
}

export interface SectionPage {
  entries: ShelfEntry[]
  page: PageResult
}

export type ShelfSection = SectionPage & {
  id: string
  title?: string
  type?: ShelfType
}

export interface Shelf {
  type?: ShelfType
  title?: string
  sections: ShelfSection[]
  accessInfo: ContentAccessInfo
  collapsible?: boolean
  itemsTotal?: number
}

export interface Content {
  recommendedContent: ShelfEntry | null
  shelves: Shelf[]
}

export type StoreContent = ReturnType<typeof selectLibraryContent>

export type StoreRecommendedItem = StoreContent['recommendedItem']

export type StoreShelf = StoreContent['shelves'][0]

export type StoreShelfSection = StoreShelf['sections'][0]

export type StoreShelfEntry = StoreShelfSection['entries'][0]

export enum ActionType {
  GetLibrary = 'Library/get_library',
  UpdateSectionEntries = 'Library/update_section_entries',
  SetShouldRefetchLibrary = 'Library/set_should_refetch_library',
  GetTimeSpent = 'Library/get_time_spent'
}

export type GetLibrary = {
  type: ActionType.GetLibrary
  libraryContent: Content
}
export type GetLibraryShelfPage = {
  type: ActionType.UpdateSectionEntries
  newSectionPage: SectionPage
  sectionId: string
}

export type SetShouldRefetchLibrary = {
  type: ActionType.SetShouldRefetchLibrary
  shouldRefetch: boolean
}

export type GetTimeSpentAction = {
  type: ActionType.GetTimeSpent
  timeSpent: number
}

export type Action = GetLibrary | GetLibraryShelfPage | SetShouldRefetchLibrary | GetTimeSpentAction | LogoutAction

export type State = {
  libraryContent: Content
  shouldRefetchLibrary: boolean
  timeSpent: number
  dailyGoal: number
  isDailyGoalAchieved: boolean
}

export enum LabelType {
  STARS = 'stars',
  LOCK = 'lock',
  PRO_ACTIVITY = 'pro-activity',
  PREMIUM_ACTIVITY = 'premium-activity',
  GIFT_ACTIVITY = 'gift-activity',
  DONE_ACTIVITY = 'done-activity',
  FREE_TIER = 'free-tier',
  PREMIUM_TIER = 'premium-tier',
  PRO_TIER = 'pro-tier'
}

export type LabelConfig = {
  title?: string
  textColor?: string
  backgroundColor: string
  renderIcon?: (large?: boolean) => JSX.Element
}

export type LabelProps = {
  type: LabelType
  title?: string
  withoutText?: boolean
  large?: boolean
}
